var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_5802)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.325938 12.4999C0.576302 12.7409 0.981211 12.7409 1.23096 12.4999L6.52445 7.3912C6.64294 7.27859 6.73729 7.14305 6.80177 6.99284C6.86624 6.84262 6.89949 6.68086 6.89949 6.5174C6.89949 6.35393 6.86624 6.19217 6.80177 6.04195C6.73729 5.89174 6.64294 5.75621 6.52445 5.6436L1.19263 0.49723C1.07162 0.382216 0.911378 0.31757 0.744436 0.316422C0.577494 0.315274 0.416373 0.377709 0.293795 0.491048C0.233073 0.547019 0.184486 0.614859 0.151045 0.690368C0.117604 0.765877 0.100021 0.847448 0.0993831 0.930028C0.0987456 1.01261 0.115068 1.09444 0.147339 1.17046C0.17961 1.24647 0.227144 1.31506 0.286995 1.37196L5.16692 6.08065C5.22622 6.13696 5.27343 6.20475 5.3057 6.27988C5.33796 6.35502 5.3546 6.43593 5.3546 6.51771C5.3546 6.59948 5.33796 6.68039 5.3057 6.75553C5.27343 6.83067 5.22622 6.89845 5.16692 6.95476L0.325938 11.6264C0.266661 11.6826 0.219456 11.7503 0.187197 11.8254C0.154939 11.9005 0.138303 11.9814 0.138303 12.0631C0.138303 12.1448 0.154939 12.2257 0.187197 12.3008C0.219455 12.3759 0.266661 12.4436 0.325938 12.4999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_5802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.8,
    height: 12.3636,
    fill: "white",
    transform: "translate(0.0998535 0.316406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.678123b45a88c3d85345ee6968aba0f4.svg";
export { ForwardRef as ReactComponent };